// https://learn.microsoft.com/en-us/clarity/setup-and-installation/clarity-consent-api-v2

window.addEventListener('load', () => {
  const cookiesBannerElement = document.querySelector('#shopify-pc__banner')
  const cookiesAcceptButtonElement = cookiesBannerElement.querySelector('.shopify-pc__banner__btn-accept')

  cookiesAcceptButtonElement.addEventListener('click', () => {
    window.clarity('consentv2', {
      ad_Storage: "granted",
      analytics_Storage: "granted"
    });
  })
})
